/* unplugin-vue-components disabled */import { render } from "./load.vue?vue&type=template&id=d8d66a2e&scoped=true"
const script = {}

import "./load.vue?vue&type=style&index=0&id=d8d66a2e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8d66a2e"]])

export default __exports__